import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { MedIconBorderAllComponent } from "./med-icon-border-all.component";

@NgModule({
  declarations: [
    MedIconBorderAllComponent,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    MedIconBorderAllComponent,
  ],
})
export class MedIconBorderAllModule { }
